import * as React from 'react';
import { useRef } from 'react';
import { useCookieConsentContext, isCookieCategoryEnabled } from '@grandvisionhq/cookie-consent';

function TrustedShops({ trustedShopsId , ScriptComponent  }) {
    const strategy = useRef('beforeInteractive');
    const consentResult = useCookieConsentContext();
    if (!isCookieCategoryEnabled('functional', consentResult)) {
        // the beforeInteractive strategy won't inject the script after effects
        strategy.current = 'afterInteractive';
        return null;
    }
    const TRUSTED_SHOPS_INIT = `var _tsConfig={
    yOffset: '0',
    variant: 'reviews',customElementId: '',
    trustcardDirection: '',
    customBadgeWidth: '',
    customBadgeHeight: '',
    disableResponsive: 'true',
    disableTrustbadge: 'false'
  }`;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ScriptComponent, {
        strategy: strategy.current
    }, TRUSTED_SHOPS_INIT), /*#__PURE__*/ React.createElement(ScriptComponent, {
        strategy: strategy.current,
        src: `https://widgets.trustedshops.com/js/${trustedShopsId}.js`
    }));
}

export { TrustedShops, TrustedShops as default };
//# sourceMappingURL=TrustedShops.js.map
